import React from 'react'
import './About.scss';
import nftAbout from '../../Images/nftabout.png'

function About() {
    return (
        <div id="about">
            <div className='row'>
                <div className='col-lg'>
                    <div className='aboutCard'>
                        <h1>ABOUT</h1>
                        <p className='subTitle'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>
                    </div>
                    <div className='aboutCard'>
                        <h1>MORE INFO</h1>
                        <p className='subTitle'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>
                    </div>
                    <div className='aboutCard'>
                        <h1>MORE INFO</h1>
                        <p className='subTitle'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</p>
                    </div>
                </div>
                <div className='col-lg'>
                    <div className='imageCard'>
                        <img className='aboutImage' src={nftAbout} alt="nft" />
                        <p className='cardTitle'>Space Ape Voyage</p>
                        <p className='subTitle'>Lorem ipsum dolor sit amet, consectetur adipiscing</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About
